// import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
@Injectable()
export class SharedRefreshService {
    // Observable string sources
    private emitReloadSource = new Subject<any>();
    // Observable string streams
    refreshEmitted = this.emitReloadSource.asObservable();
    // Service message commands
    refresh(reload: boolean) {
        this.emitReloadSource.next(reload);
    }
}
